import React from 'react'

export default function DynamicListTypes(props) {
  const { listData } = props
  const dynamicListsTypes = [
    {
      name: 'Filters',
      label: 'Movies',
      value: 'movies',
    },
    {
      name: 'Trending',
      label: 'Trending Lists',
      value: 'trendingLists',
    },
  ]

  return (
    <div className='row d-flex ml-3'>
      {dynamicListsTypes.map((dynamicListType, index) => (
        <div key={index} className='custom-control custom-radio col-md-3'>
          <input
            type='radio'
            onClick={() => props.handleListData('dynamicListType', dynamicListType.value)}
            checked={listData.dynamicListType === dynamicListType.value}
            id={dynamicListType.name}
            name='dynamicListType'
            className='custom-control-input'
          />
          <label className='custom-control-label' htmlFor={dynamicListType.name}>
            {dynamicListType.label}
          </label>
        </div>
      ))}
    </div>
  )
}
